/**
 * Global navigation hook for non-React contexts (axios interceptors,
 * deep-link handler). Stash the React Router navigate function during
 * <App /> mount; non-React modules call it to redirect on auth failure.
 */
type NavigateFn = (path: string, options?: { replace?: boolean }) => void;

let navigator: NavigateFn | null = null;

export function setGlobalNavigator(fn: NavigateFn): void {
  navigator = fn;
}

export function navigateTo(path: string, options?: { replace?: boolean }): void {
  if (navigator) {
    navigator(path, options);
  } else if (typeof window !== 'undefined') {
    if (options?.replace) {
      window.location.replace(path);
    } else {
      window.location.href = path;
    }
  }
}
